import React from 'react';
import { CalendarIcon, ClockIcon, VideoIcon, UsersIcon, MapPinIcon } from 'lucide-react';
const UpcomingEventsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1288">
      <div className="p-4 flex justify-between items-center" data-id="element-1289">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-1290">
          Eventi Imminenti
        </h2>
        <button className="text-sm text-gray-500 hover:text-gray-700 font-normal transition-colors" data-id="element-1291">
          Visualizza Calendario
        </button>
      </div>
      <div className="p-4" data-id="element-1292">
        <div className="space-y-4" data-id="element-1293">
          <EventItem title="Workshop Innovazione Sostenibile" date="Oggi" time="14:00 - 15:30" type="webinar" location="Zoom" data-id="element-1294" />
          <EventItem title="Discussione Tecnologie Green" date="Domani" time="11:00 - 12:00" type="meeting" location="Milano, Via Torino 12" data-id="element-1295" />
          <EventItem title="Casi Studio Economia Circolare" date="25 Maggio" time="14:00 - 16:00" type="webinar" location="Google Meet" data-id="element-1296" />
        </div>
      </div>
    </div>;
};
interface EventItemProps {
  title: string;
  date: string;
  time: string;
  type: 'webinar' | 'meeting' | 'deadline';
  location?: string;
}
const EventItem: React.FC<EventItemProps> = ({
  title,
  date,
  time,
  type,
  location
}) => {
  const getEventIcon = () => {
    switch (type) {
      case 'webinar':
        return <VideoIcon size={16} className="text-gray-500" strokeWidth={1.5} data-id="element-1297" />;
      case 'meeting':
        return <UsersIcon size={16} className="text-gray-500" strokeWidth={1.5} data-id="element-1298" />;
      case 'deadline':
        return <ClockIcon size={16} className="text-gray-500" strokeWidth={1.5} data-id="element-1299" />;
      default:
        return null;
    }
  };
  const getTypeLabel = () => {
    switch (type) {
      case 'webinar':
        return 'Webinar';
      case 'meeting':
        return 'Incontro';
      case 'deadline':
        return 'Scadenza';
      default:
        return '';
    }
  };
  const getLocationIcon = () => {
    if (type === 'webinar') {
      return <VideoIcon size={12} className="text-gray-500" strokeWidth={1.5} data-id="element-1300" />;
    } else if (type === 'meeting') {
      return <MapPinIcon size={12} className="text-gray-500" strokeWidth={1.5} data-id="element-1301" />;
    }
    return null;
  };
  return <div className="flex" data-id="element-1302">
      <div className="mr-3 mt-1" data-id="element-1303">
        <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-1304">
          <CalendarIcon size={18} className="text-gray-600" strokeWidth={1.5} data-id="element-1305" />
        </div>
      </div>
      <div className="flex-1" data-id="element-1306">
        <h3 className="font-medium text-gray-800 text-sm" data-id="element-1307">{title}</h3>
        <div className="text-sm text-gray-500 font-normal mb-1" data-id="element-1308">
          {date} • {time}
        </div>
        <div className="flex items-center flex-wrap gap-x-2 gap-y-1 text-xs" data-id="element-1309">
          <div className="flex items-center" data-id="element-1310">
            <span className="mr-1" data-id="element-1311">{getEventIcon()}</span>
            <span className="text-gray-600 font-normal" data-id="element-1312">{getTypeLabel()}</span>
          </div>
          {location && <>
              <span className="text-gray-400" data-id="element-1313">•</span>
              <div className="flex items-center" data-id="element-1314">
                <span className="mr-1" data-id="element-1315">{getLocationIcon()}</span>
                <span className="text-gray-600 font-normal" data-id="element-1316">{location}</span>
              </div>
            </>}
          {date === 'Oggi' && <>
              <span className="text-gray-400" data-id="element-1317">•</span>
              <span className="text-green-600 font-medium" data-id="element-1318">
                Inizia tra 3 ore
              </span>
            </>}
        </div>
      </div>
    </div>;
};
export default UpcomingEventsWidget;